import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { content, LANGS } from "@/i18n/content";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("madinaty_lang") || "ar");

  const dir = LANGS.find((l) => l.code === lang)?.dir || "rtl";

  useEffect(() => {
    localStorage.setItem("madinaty_lang", lang);
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", dir);
    document.body.classList.toggle("font-latin", lang === "en");
    document.body.classList.toggle("font-arabic", lang !== "en");
  }, [lang, dir]);

  const changeLang = useCallback((code) => setLang(code), []);

  const t = content[lang];

  return (
    <LanguageContext.Provider value={{ lang, dir, t, changeLang, langs: LANGS }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
